export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13552.41f99cb0.jpg";